import { render, staticRenderFns } from "./Evaluation-attempts-search.vue?vue&type=template&id=4f8c8a4e&scoped=true"
import script from "./Evaluation-attempts-search.vue?vue&type=script&lang=js"
export * from "./Evaluation-attempts-search.vue?vue&type=script&lang=js"
import style0 from "./Evaluation-attempts-search.vue?vue&type=style&index=0&id=4f8c8a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c8a4e",
  null
  
)

export default component.exports